import { RESPONSE_TYPE } from "../const/vote";
import { IOptInConfig } from "./ballot-opt-in";
import { ICandidate } from "./candidate";
export enum BALLOT_FORMAT {
    DRAG_DROP = "DRAG_DROP",
    NUMBER_BOX = "NUMBER_BOX"
}
export enum BALLOT_STATUS {
    ENABLED = "ENABLED",
    DISABLED = "DISABLED",
    READ_ONLY = 'READ_ONLY',
    HIDDEN = "HIDDEN",
    DELETED = "DELETED",
}

export enum CANDIDATE_DISPLAY_FORMAT {
    IMAGE_PRIORITY = "IMAGE_PRIORITY",
    LABEL_PRIORITY = "LABEL_PRIORITY",
}


export interface IProxyVote {
    voter_id: string;
    label: string;
    submitted: boolean;
    self: boolean;
}

export interface QuestionInterfacePreference {
    format: BALLOT_FORMAT;
    show_min: boolean;
    show_max: boolean;
}


export interface IQuestion {
    id: string;
    created_at: Date;
    ballot_id: string;
    page_id?: string;
    label: string;
    status: BALLOT_STATUS;
    response_type: RESPONSE_TYPE;
    required: boolean;
    calculation_config?: any;
    short_description?: string;
    shuffle_candidates: boolean;
    available_seats?: number;
    exclusive_set?: string;
    exclusive_priority?: number;
    silo_by_tag?: string;
    instructions?: string;
    display_order?: number;
    min_ranking?: number;
    max_ranking?: number;
    entry_format?: BALLOT_FORMAT;
    voting_config?: any;
    item_label?: string;
    candidate_display_format?: CANDIDATE_DISPLAY_FORMAT;
}




export interface IBallot {
    id: string;
    created_at: Date;
    deleted_at?: Date;
    election_id: string;
    label: string;
    required: boolean;
    status: BALLOT_STATUS;
    short_description?: string;
    display_order?: number;
    opt_in_config?: any;
}